export class ContactModel {
    contactId: number;
    phone1: string;
    phone2: string | null;
    email: string | null;
    createdAt: Date | any;
    updatedAt: Date | any;
    createdUser?: string;
    updatedUser?: string;
    versionFlag?: number;
    constructor(contactId: number, phone1: string | null, phone2: string, email: string | null, createdAt?: Date | any, updatedAt?: Date | any,
        createdUser?: string, updatedUser?: string, versionFlag?: number) {
        this.contactId = contactId;
        this.phone1 = phone1;
        this.phone2 = phone2;
        this.email = email;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
    }
}


export const ContactModelDefault: ContactModel = {
    contactId: 0,
    phone1: '',
    phone2: '',
    email: '',
    createdAt: new Date(),
    updatedAt: new Date(),
    createdUser: '',
    updatedUser: '',
    versionFlag: 0,
}